function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.436 2.974C2.436 1.884 3.32 1 4.41 1h7.18c1.09 0 1.974.884 1.974 1.974v10.95h.897a.538.538 0 110 1.076H1.539a.538.538 0 010-1.077h.898V2.974zm1.077 10.95h2.513v-3.052c0-.694.562-1.257 1.256-1.257h1.436c.694 0 1.256.563 1.256 1.257v3.051h2.513V2.974a.897.897 0 00-.897-.897H4.41a.897.897 0 00-.897.897v10.95zm5.384 0v-3.052c0-.1-.08-.18-.179-.18H7.282c-.1 0-.18.08-.18.18v3.051h1.795zM5.307 4.41c0-.297.242-.538.54-.538h.717a.538.538 0 010 1.077h-.718a.538.538 0 01-.538-.539zm3.59 0c0-.297.242-.538.539-.538h.718a.538.538 0 010 1.077h-.718a.538.538 0 01-.539-.539zm-3.59 2.872c0-.297.242-.538.54-.538h.717a.538.538 0 010 1.077h-.718a.538.538 0 01-.538-.539zm3.59 0c0-.297.242-.538.539-.538h.718a.538.538 0 010 1.077h-.718a.538.538 0 01-.539-.539z",
  fill: "#2D2D2D"
});
function SvgEdificio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Edificio.svg";
export { SvgEdificio as ReactComponent };